export default "__VITE_ASSET__C2WiLn2e__"